export * from './src/quill.module';
export * from './src/quill-editor.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/ngx-quill/index.js
// module id = ../../../../ngx-quill/index.js
// module chunks = common